import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo3/aulavacia.png";
import Imagen2 from "../../../images/modulo3/maestra.png";
import Imagen3 from "../../../images/modulo3/aulasinalumnos.png";
import Imagen4 from "../../../images/modulo3/aulaalumnos.png";
import Imagen5 from "../../../images/modulo3/maltrato.png";
import Imagen6 from "../../../images/modulo3/buentrato.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo3 } from "../../../routes/Module3";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo3/Actividad 3.mp3";

const Actividad3 = () => {
  const [answersSwitch, setAnswersSwitch] = useState({
    ans1: { value: "derecho", valid: "", correctValue: "derecho" },
    ans2: { value: "derecho", valid: "", correctValue: "deber" },
    ans3: { value: "derecho", valid: "", correctValue: "derecho" },
  });
  const [answersRadio, setAnswersRadio] = useState({
    ans1: { value: "", valid: "", correctValue: "2" },
    ans2: { value: "", valid: "", correctValue: "2" },
    ans3: { value: "", valid: "", correctValue: "2" },
  });
  const infoUnidad = modulo3.content[0];
  const infoAct = modulo3.content[0].activities[2];
  const crumbs = [
    {
      title: modulo3.title,
      url: "/" + modulo3.url,
    },
    {
      title:
        modulo3.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo3.content[0].activities[3].name}`,
    linkNext: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[3].path}`,
    titlePrev: `${modulo3.content[0].activities[1].name}`,
    linkPrev: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[1].path}`,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswersRadio = answersRadio;
    Object.keys(newAnswersRadio).forEach(
      (key) =>
        (newAnswersRadio[key]["valid"] =
          answersRadio[key]["correctValue"] === answersRadio[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswersRadio({ ...newAnswersRadio });

    let newAnswersSwitch = answersSwitch;
    Object.keys(newAnswersSwitch).forEach(
      (key) =>
        (newAnswersSwitch[key]["valid"] =
          answersSwitch[key]["correctValue"] === answersSwitch[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswersSwitch({ ...newAnswersSwitch });
  };

  const metadata = {
    color: modulo3.color,
    title: `${modulo3.title} - ${infoAct.name}`,
    name: modulo3.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo3.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">Actividad 3</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>
          Los niños y niñas que asisten a las escuelas tienen derechos y también
          deberes.
        </li>
        <li>
          Lee cada una de las frases y dale clic a la palabra “derecho” o
          “deber” según corresponda.
        </li>
        <li>Luego, marca en el recuadro la imagen que se relaciona mejor con la frase.</li>
      </ul>
      <p className="mt-5">
        <strong>1: Recibir una buena enseñanza</strong>
      </p>
      <div
        className="btn-group btn-group-green"
        role="group"
        aria-label="Basic radio toggle button group"
      >
        <input
          type="radio"
          className="btn-check"
          name="sentencia1"
          value="derecho"
          checked={answersSwitch.ans1.value === "derecho" ? true : false}
          onChange={() => console.log("1")}
        />
        <label
          className={"btn btn-outline-green " + answersSwitch.ans1.valid}
          htmlFor="btnradio1"
          onClick={() =>
            setAnswersSwitch({
              ...answersSwitch,
              ans1: { ...answersSwitch["ans1"], value: "derecho" },
            })
          }
        >
          Derecho
        </label>

        <input
          type="radio"
          className="btn-check"
          name="sentencia1"
          value="deber"
          checked={answersSwitch.ans1.value === "deber" ? true : false}
          onChange={() => console.log("2")}
        />
        <label
          className={"btn btn-outline-green " + answersSwitch.ans1.valid}
          htmlFor="btnradio2"
          onClick={() =>
            setAnswersSwitch({
              ...answersSwitch,
              ans1: { ...answersSwitch["ans1"], value: "deber" },
            })
          }
        >
          Deber
        </label>
      </div>
      <div className="row activities-content mt-5">
        <div className="col-lg-5 col-md-6 col-xs-12">
          <div className="d-flex align-items-center">
            <input
              className={
                "form-check-input mb-1 form-md " + answersRadio.ans1.valid
              }
              type="radio"
              name="radioSentence1"
              value="1"
              checked={answersRadio.ans1.value === "1"}
              onChange={() => console.log("ans1")}
              onClick={() =>
                setAnswersRadio({
                  ...answersRadio,
                  ans1: { ...answersRadio["ans1"], value: "1" },
                })
              }
            />
          </div>
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className={
                "form-check-input mb-1 form-md " + answersRadio.ans1.valid
              }
              type="radio"
              name="radioSentence1"
              value="2"
              checked={answersRadio.ans1.value === "2"}
              onChange={() => console.log("ans2")}
              onClick={() =>
                setAnswersRadio({
                  ...answersRadio,
                  ans1: { ...answersRadio["ans2"], value: "2" },
                })
              }
            />
          </div>
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
      </div>

      <p>
        <strong>2: Asistir a la escuela</strong>
      </p>
      <div
        className="btn-group btn-group-green"
        role="group"
        aria-label="Basic radio toggle button group"
      >
        <input
          type="radio"
          className="btn-check"
          name="sentencia2"
          checked={answersSwitch.ans2.value === "derecho" ? true : false}
          onChange={() => console.log("")}
        />
        <label
          className={"btn btn-outline-green " + answersSwitch.ans2.valid}
          htmlFor="btnradio1"
          onClick={() =>
            setAnswersSwitch({
              ...answersSwitch,
              ans2: { ...answersSwitch["ans2"], value: "derecho" },
            })
          }
        >
          Derecho
        </label>

        <input
          type="radio"
          className="btn-check"
          name="sentencia2"
          checked={answersSwitch.ans2.value === "deber" ? true : false}
          onChange={() => console.log("")}
        />
        <label
          className={"btn btn-outline-green " + answersSwitch.ans2.valid}
          htmlFor="btnradio2"
          onClick={() =>
            setAnswersSwitch({
              ...answersSwitch,
              ans2: { ...answersSwitch["ans2"], value: "deber" },
            })
          }
        >
          Deber
        </label>
      </div>
      <div className="row activities-content mt-5">
        <div className="col-lg-5 col-md-6 col-xs-12">
          <div className="d-flex align-items-center">
            <input
              className={
                "form-check-input mb-1 form-md " + answersRadio.ans2.valid
              }
              type="radio"
              name="radioSentence2"
              value="1"
              checked={answersRadio.ans2.value === "1"}
              onChange={() => console.log("ans2")}
              onClick={() =>
                setAnswersRadio({
                  ...answersRadio,
                  ans2: { ...answersRadio["ans2"], value: "1" },
                })
              }
            />
          </div>
          <img src={Imagen3} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className={
                "form-check-input mb-1 form-md " + answersRadio.ans2.valid
              }
              type="radio"
              name="radioSentence2"
              value="2"
              checked={answersRadio.ans2.value === "2"}
              onChange={() => console.log("ans2")}
              onClick={() =>
                setAnswersRadio({
                  ...answersRadio,
                  ans2: { ...answersRadio["ans2"], value: "2" },
                })
              }
            />
          </div>
          <img src={Imagen4} alt="Familia" className="img-fluid" />
        </div>
      </div>

      <p>
        <strong>3: Recibir un buen trato</strong>
      </p>
      <div
        className="btn-group btn-group-green"
        role="group"
        aria-label="Basic radio toggle button group"
      >
        <input
          type="radio"
          className="btn-check"
          name="sentencia3"
          checked={answersSwitch.ans3.value === "derecho" ? true : false}
          onChange={() => console.log("")}
        />
        <label
          className={"btn btn-outline-green " + answersSwitch.ans3.valid}
          htmlFor="btnradio1"
          onClick={() =>
            setAnswersSwitch({
              ...answersSwitch,
              ans3: { ...answersSwitch["ans3"], value: "derecho" },
            })
          }
        >
          Derecho
        </label>

        <input
          type="radio"
          className="btn-check"
          name="sentencia3"
          checked={answersSwitch.ans3.value === "deber" ? true : false}
          onChange={() => console.log("")}
        />
        <label
          className={"btn btn-outline-green " + answersSwitch.ans3.valid}
          htmlFor="btnradio2"
          onClick={() =>
            setAnswersSwitch({
              ...answersSwitch,
              ans3: { ...answersSwitch["ans3"], value: "deber" },
            })
          }
        >
          Deber
        </label>
      </div>
      <div className="row activities-content mt-5">
        <div className="col-lg-5 col-md-6 col-xs-12">
          <div className="d-flex align-items-center">
            <input
              className={
                "form-check-input mb-1 form-md " + answersRadio.ans3.valid
              }
              type="radio"
              name="radioSentence3"
              value="1"
              checked={answersRadio.ans3.value === "1"}
              onChange={() => console.log("ans3")}
              onClick={() =>
                setAnswersRadio({
                  ...answersRadio,
                  ans3: { ...answersRadio["ans3"], value: "1" },
                })
              }
            />
          </div>
          <img src={Imagen5} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-xs-12 mb-5">
          <div className="d-flex align-items-center">
            <input
              className={
                "form-check-input mb-1 form-md " + answersRadio.ans3.valid
              }
              type="radio"
              name="radioSentence3"
              value="2"
              checked={answersRadio.ans3.value === "2"}
              onChange={() => console.log("ans3")}
              onClick={() =>
                setAnswersRadio({
                  ...answersRadio,
                  ans3: { ...answersRadio["ans3"], value: "2" },
                })
              }
            />
          </div>
          <img src={Imagen6} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="row my-4">
        <div className="col-lg-10 col-12">
          <button
            className={`btn float-end btn-${modulo3.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Explique qué significa tener derechos y tener deberes. Lea la primera
          frase en voz alta y pregunte si es un derecho o un deber. Luego, pida
          que describan las imágenes que acompañan la frase y que elijan cuál se
          relaciona mejor con esta. Continúe así con el resto de frases.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
